'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.setMajorName = setMajorName;
exports.reloadHiscoreMajorList = reloadHiscoreMajorList;
exports.loadMoreHiscoreMajorList = loadMoreHiscoreMajorList;
var RELOAD_HISCORE_MAJOR_LIST = 'bp/hiscore/major/list/RELOAD_HISCORE_MAJOR_LIST';
var RELOAD_HISCORE_MAJOR_LIST_SUCCESS = 'bp/hiscore/major/list/RELOAD_HISCORE_MAJOR_LIST_SUCCESS';
var RELOAD_HISCORE_MAJOR_LIST_FAIL = 'bp/hiscore/major/list/RELOAD_HISCORE_MAJOR_LIST_FAIL';

var LOAD_MORE_HISCORE_MAJOR_LIST = 'bp/hiscore/major/list/LOAD_MORE_HISCORE_MAJOR_LIST';
var LOAD_MORE_HISCORE_MAJOR_LIST_SUCCESS = 'bp/hiscore/major/list/LOAD_MORE_HISCORE_MAJOR_LIST_SUCCESS';
var LOAD_MORE_HISCORE_MAJOR_LIST_FAIL = 'bp/hiscore/major/list/LOAD_MORE_HISCORE_MAJOR_LIST_FAIL';

var SET_MAJORNAME = 'bp/hiscore/major/list/SET_MAJORNAME';

var initState = {
    loading: true,
    majorList: [],
    pager: {},
    searchName: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];

    switch (action.type) {
        case RELOAD_HISCORE_MAJOR_LIST:
            return _extends({}, state, {
                loading: true,
                majorList: [],
                pager: {}
            });
        case RELOAD_HISCORE_MAJOR_LIST_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    majorList: [],
                    pager: null,
                    loading: false
                });
            }
            return _extends({}, state, {
                majorList: action.result.data.data,
                pager: action.result.data.pager,
                loading: false
            });
        case LOAD_MORE_HISCORE_MAJOR_LIST_SUCCESS:
            {
                if (!action.result.data.success) {
                    return state;
                }
                var res = _extends({}, state, {
                    loading: false,
                    pager: action.result.data.pager
                });
                res.majorList = res.majorList.concat(action.result.data.data);
                return res;
            }
        case SET_MAJORNAME:
            return _extends({}, state, {
                searchName: action.searchName
            });
        default:
            return state;
    }
}

function setMajorName(searchName) {
    return {
        type: SET_MAJORNAME,
        searchName: searchName
    };
}

function _reloadHiscoreMajorList(query) {
    return {
        types: [RELOAD_HISCORE_MAJOR_LIST, RELOAD_HISCORE_MAJOR_LIST_SUCCESS, RELOAD_HISCORE_MAJOR_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/hiscore/rank/major', query);
            }

            return promise;
        }(),
        query: query
    };
}

function _loadMoreHiscoreMajorList(query, callback) {
    return {
        types: [LOAD_MORE_HISCORE_MAJOR_LIST, LOAD_MORE_HISCORE_MAJOR_LIST_SUCCESS, LOAD_MORE_HISCORE_MAJOR_LIST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/hiscore/rank/major', query);
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, response) {
                if (callback) {
                    callback();
                }
            }

            return afterSuccess;
        }()
    };
}

function _createQuery(state) {
    var query = {
        batchId: state.batchId,
        majorName: state.searchName,
        page: state.pager ? state.pager.page + 1 : 1,
        size: 24
    };
    return query;
}

function reloadHiscoreMajorList(batchId, searchName) {
    return function (dispatch, getState) {
        dispatch(setMajorName(searchName ? searchName : ''));
        var state = getState().hiscoreMajorList;
        state.pager = null;
        state.batchId = batchId;
        state.searchName = searchName;
        var query = _createQuery(state);
        dispatch(_reloadHiscoreMajorList(query));
    };
}

function loadMoreHiscoreMajorList(batchId, callback) {
    return function (dispatch, getState) {
        var state = getState().hiscoreMajorList;
        if (state.pager && state.pager.page && state.pager.page == state.pager.totalPages) {
            return;
        }
        state.batchId = batchId;
        var query = _createQuery(state);
        dispatch(_loadMoreHiscoreMajorList(query, callback));
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/hiscore/hiscoreMajorList.js
// module id = 499
// module chunks = 0